var map = {
	"./alto-risco.svg": 33382,
	"./baixo-risco.svg": 83571,
	"./bars-staggered-solid.svg": 57095,
	"./consulta-icon.svg": 82091,
	"./file-invoice-solid.svg": 9494,
	"./healthicons_nurse-outline.svg": 18186,
	"./house-medical-solid.svg": 27958,
	"./ic_outline-change-circle.svg": 10320,
	"./icon-agenda.svg": 48910,
	"./icon-back.svg": 21972,
	"./icon-bond.svg": 38,
	"./icon-calendar.svg": 49159,
	"./icon-card-business.svg": 69621,
	"./icon-change.svg": 96794,
	"./icon-check-solid-green1.svg": 72795,
	"./icon-circle-exclamation.svg": 14653,
	"./icon-close-modal.svg": 66321,
	"./icon-doc.svg": 27088,
	"./icon-filter-blue.svg": 84379,
	"./icon-filter-green.svg": 11621,
	"./icon-filter.svg": 90781,
	"./icon-help.svg": 74197,
	"./icon-home.svg": 6750,
	"./icon-ine.svg": 24042,
	"./icon-instagram.svg": 57758,
	"./icon-item2.svg": 12995,
	"./icon-item4.svg": 79190,
	"./icon-item5.svg": 16769,
	"./icon-item6.svg": 76229,
	"./icon-item7.svg": 69148,
	"./icon-lattes.svg": 53900,
	"./icon-linkedin.svg": 89596,
	"./icon-logoff.svg": 12583,
	"./icon-map-pin-gray.svg": 1095,
	"./icon-map-pin.svg": 63292,
	"./icon-menu.svg": 80769,
	"./icon-more-vertical.svg": 94078,
	"./icon-plus-white.svg": 11623,
	"./icon-preparo.svg": 87709,
	"./icon-relatorio-aplicacao.svg": 70841,
	"./icon-required.svg": 62889,
	"./icon-right-white.svg": 64180,
	"./icon-right.svg": 6694,
	"./icon-search.svg": 39928,
	"./icon-sigtap.png": 42351,
	"./icon-solicitacoes-encerradas.svg": 67309,
	"./icon-subtract.svg": 14973,
	"./icon-success-solid.svg": 49474,
	"./icon-sum.png": 76520,
	"./icon-upload.svg": 53068,
	"./icon-vinculo.svg": 71907,
	"./icon-vinculos.svg": 41007,
	"./icon_check-all.svg": 66100,
	"./icon_circle-check.svg": 43662,
	"./icon_dados_paciente.svg": 75731,
	"./icon_dados_unidade.svg": 58491,
	"./icon_map.svg": 21944,
	"./icon_predio.svg": 32053,
	"./icon_search.png": 86429,
	"./icons8-user-male.svg": 98759,
	"./la_upload.svg": 69998,
	"./medio-risco.svg": 24944,
	"./muito-alto-risco.svg": 47322,
	"./radio-bg.svg": 18917,
	"./star-half-stroke-regular.svg": 4681,
	"./user-example.png": 36257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44140;